import styled, { css } from 'styled-components';
import Input from '@ui-library/input';
import theme from '@css/theme';

const borderModification = css`
  .ant-table-thead {
    .ant-table-cell {
      color: ${({ theme }) => theme.color.neutral1};
      font-weight: 500;
      font-size: 14px;
    }
  }

  .ant-table-thead
    > tr
    th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
    display: none;
  }

  .ant-table-container {
    box-shadow: 0px 2px 8px rgb(0 0 0 / 5%);
    border-radius: 4px;
    border: 1px solid #f0f0f0;
  }

  .ant-table-tbody > tr:last-child td {
    border: 0;
  }
`;

export const Container = styled.div<{ readOnly?: boolean; version: 1 | 2 }>`
  ${(props) => props.version === 2 && borderModification}
  .ant-table-row {
    cursor: ${(props) => (props.readOnly ? 'auto' : 'pointer')};
    &:hover {
      background: ${theme.color.background1} !important;
    }
    height: 54px;
  }
`;

export const StyledInput = styled(Input)`
  margin-top: -53px;
  height: 50px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  font-family: Noto Sans;
  font-style: normal;
  color: ${theme.color.neutral1};
`;
